// Signed-in Discord profile bits the client caches locally so the UI can act on
// identity WITHOUT a round-trip (ADR-0009 want page). The Firebase user object
// only carries the Discord *display* name; the want-page URL slug
// (/u/@<username>/wantlist) is the Discord *username*, which only the OAuth
// response knows. We persist it so the sidebar links straight to the real handle
// (never the generic @me) — even on a restored session with no fresh OAuth.
//
// Pure + storage-injectable so it unit-tests without a DOM (pass a fake storage);
// defaults to localStorage in the browser.

const DISCORD_USERNAME_KEY = 'discord_username';

function defaultStorage() {
  return typeof localStorage !== 'undefined' ? localStorage : null;
}

/** @typedef {import('../types.js').StorageLike} StorageLike */

/**
 * Persist the signed-in user's Discord username slug. No-op for a falsy value.
 * @param {string | null | undefined} username
 * @param {StorageLike | null} [storage]
 */
export function storeDiscordUsername(username, storage = defaultStorage()) {
  if (!username || !storage) return;
  try {
    storage.setItem(DISCORD_USERNAME_KEY, username);
  } catch {
    /* private mode / quota — non-fatal, we just fall back to @me */
  }
}

/**
 * Read the cached Discord username slug, or null if none/unavailable.
 * @param {StorageLike | null} [storage]
 * @returns {string | null}
 */
export function loadDiscordUsername(storage = defaultStorage()) {
  if (!storage) return null;
  try {
    return storage.getItem(DISCORD_USERNAME_KEY) || null;
  } catch {
    return null;
  }
}

/**
 * Drop the cached username (on sign-out / anonymous).
 * @param {StorageLike | null} [storage]
 */
export function clearDiscordUsername(storage = defaultStorage()) {
  if (!storage) return;
  try {
    storage.removeItem(DISCORD_USERNAME_KEY);
  } catch {
    /* non-fatal */
  }
}
